import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "vr",
  "use": "vr-usage",
  "viewBox": "0 0 42.37 23.06",
  "content": "<symbol viewBox=\"0 0 42.37 23.06\" id=\"vr\"><title>VR</title><g id=\"vr_Calque_2\" data-name=\"Calque 2\"><g id=\"vr_Layer_1\" data-name=\"Layer 1\"><path d=\"M21.22,0H0V23.06H14.59l6.6-6.56,6.59,6.56H42.37V0ZM10.94,15.84a5.13,5.13,0,1,1,5.12-5.12A5.13,5.13,0,0,1,10.94,15.84Zm20.5,0a5.13,5.13,0,1,1,5.12-5.12A5.13,5.13,0,0,1,31.44,15.84Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/bottom/sprite/vr.svg
// module id = jzDU
// module chunks = 1